import LogoutIcon from '@mui/icons-material/Logout'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import {
  Button,
  Card,
  CardContent,
  DialogContentText,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Tooltip,
  Typography
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/system'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutUser, MENU_OPEN } from '../../../../store/actions'
import ConfirmDialog from '../../../../views/modals/ConfirmDialog'
import { subMenu } from '../../../menu-items'
import UserAvatar from '../../../ui-components/UserAvatar'
import MenuList from '../MenuList'
import { clearCampaignList, clearStore } from '../../../../store/actions/campaign/list'
import newBieBackground from '../../../../assets/staterBackground.webp'
import { revokeUserAccess, settingUser } from '../../../../store/actions/setting'

const CardStyle = styled(Card)(({ theme }: any) => ({
  background: theme.palette.primary.light,
  marginBottom: '22px',
  position: 'relative'
}))

const MenuCard = () => {
  const dispatch: any = useDispatch()
  const [isRevoke, setIsRevoke] = useState<boolean>(false)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const client = useSelector((state: any) => state.apolloClient.client)
  const userDetails = useSelector((state: any) => state.settingReducer.userDetails)

  const handleUserLogout = () => {
    navigate('/')
    dispatch(logoutUser())
    dispatch({ type: MENU_OPEN, id: 'menu-dashboard' })
    dispatch(clearCampaignList())
    dispatch(clearStore())
  }

  const refreshHandler = () => {
    dispatch(settingUser(client))
  }

  const handleRevokeMasterAccount = () => {
    setIsRevoke(false)
    setOpen(false)
    const req = { email: userDetails?.email, user_id: userDetails?._id, delete: true }
    dispatch(revokeUserAccess(client, req, refreshHandler))
  }

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <CardStyle className="sidebar_card" sx={{ padding: '0 12px 0px 16px' }}>
      <Box>
        <MenuList menuItem={subMenu} />
      </Box>
      {userDetails?.access_account && (
        <CardContent sx={{ p: 0 }}>
          <List
            sx={{
              position: 'relative',
              p: 2,
              borderRadius: '8px',
              background: `url(${newBieBackground})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <Box sx={{ marginBottom: '12px' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <AutoAwesomeIcon
                  sx={{
                    width: '16px',
                    height: '16px',
                    color: '#6366f1'
                  }}
                />
                <Typography
                  sx={{
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#4f46e5',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}
                >
                  Account Access
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ListItemAvatar sx={{ mt: 0 }}>
                  <UserAvatar
                    name={
                      userDetails?.access_account?.full_name
                        ? userDetails?.access_account?.full_name
                        : userDetails?.access_account?.email
                    }
                    profile_image={userDetails?.access_account?.profile_image}
                  />
                </ListItemAvatar>

                <ListItemText
                  primary={
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: '600',
                        fontSize: '14px',
                        lineHeight: '20px',
                        color: '#344054'
                      }}
                    >
                      <Tooltip title={userDetails?.access_account?.full_name} placement="top">
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {userDetails?.access_account?.full_name}
                        </div>
                      </Tooltip>
                    </Typography>
                  }
                  secondary={
                    <Typography variant="caption" style={{ color: '#475467' }}>
                      <Tooltip title={userDetails?.access_account?.email} placement="top">
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {userDetails?.access_account?.email}
                        </div>
                      </Tooltip>
                    </Typography>
                  }
                />
              </Box>
              <Box sx={{ textAlign: 'end' }}>
                <Button
                  style={{ color: 'red', padding: '1px', margin: '0px', textDecoration: 'underline' }}
                  onClick={(e: any) => {
                    e.stopPropagation()
                    setIsRevoke(true)
                    handleClickOpen()
                  }}
                >
                  <Tooltip title="Remove Access" placement="top-end">
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px' }}>Remove Access</div>
                  </Tooltip>
                </Button>
              </Box>
            </Box>
          </List>
        </CardContent>
      )}

      <CardContent sx={{ p: 2 }}>
        <List sx={{ p: 0, m: 0 }}>
          <ListItem alignItems="flex-start" disableGutters sx={{ p: 0 }}>
            <ListItemAvatar sx={{ mt: 0 }}>
              <UserAvatar
                name={userDetails?.full_name ? userDetails?.full_name : userDetails?.email}
                profile_image={userDetails?.profile_image}
              />
            </ListItemAvatar>
            <ListItemText
              sx={{ mt: 0 }}
              primary={
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: '600',
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#344054'
                  }}
                >
                  <Tooltip title={userDetails?.full_name} placement="top">
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{userDetails?.full_name}</div>
                  </Tooltip>
                </Typography>
              }
              secondary={
                <Typography variant="caption" style={{ color: '#475467' }}>
                  <Tooltip title={userDetails?.email} placement="top">
                    <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{userDetails?.email}</div>
                  </Tooltip>
                </Typography>
              }
            />
            <Tooltip title="Log Out" placement="top-end">
              <IconButton
                onClick={(e: any) => {
                  e.stopPropagation()
                  setIsRevoke(false)
                  handleClickOpen()
                }}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </ListItem>
        </List>
      </CardContent>
      {open && (
        <ConfirmDialog
          open={open}
          handleClose={handleClose}
          onConform={() => {
            isRevoke ? handleRevokeMasterAccount() : handleUserLogout()
          }}
          title={isRevoke ? 'Remove Access' : 'Log out'}
          message={
            isRevoke
              ? `Are you sure you wish to remove your access to the account: ${userDetails?.access_account?.email}? To regain access you’ll need to ask the account owner`
              : 'Are you sure you want to Log out?'
          }
          renderMessage={
            isRevoke ? (
              <DialogContentText sx={{ mr: 4 }} id="alert-dialog-slide-description">
                <span>Are you sure you wish to remove your access to the account:</span>
                <br />  
                <strong style={{ color: 'grey' }}>{userDetails?.access_account?.email}</strong>
                <br />
                <span>To regain access you’ll need to ask the account owner.</span>
              </DialogContentText>
            ) : undefined
          }
        />
      )}
    </CardStyle>
  )
}
export default MenuCard
